import { render } from "./Category.vue?vue&type=template&id=0ea8081f"
import script from "./Category.vue?vue&type=script&lang=ts"
export * from "./Category.vue?vue&type=script&lang=ts"
script.render = render

export default script